<template>
  <div class="upload">
    <ul class="upload-images">
      <li v-for="(item, index) in selectFiles" :key="index">
        <v-img :src="item.preview" aspect-ratio="1" @click="lightbox(item.preview)" contain>
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
        <div class="mask">
          <v-icon @click.stop="fileRemove(index)">fas fa-trash-alt</v-icon>
        </div>
      </li>
      <li class="file-select" @click.stop="onFocus">
        <v-container fill-height>
          <v-layout align-center justify-center>
            <div v-if="!uploading">
              <v-icon large>far fa-file-image</v-icon>
            </div>
            <div v-else>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </div>
          </v-layout>
        </v-container>
      </li>
    </ul>
    <input ref="fileInput" type="file" :accept="accept" @change="onFileChange" multiple />
    <div class="mt-2">
      <v-btn
        @click.stop="upload"
        tile text small>
        <v-icon left>fas fa-cloud-upload-alt</v-icon>
        アップロード
      </v-btn>
    </div>
  </div>
</template>

<script>
import { Storage } from 'aws-amplify'
import moment from 'moment'
import imageCompression from 'browser-image-compression'

export default {
  data() {
    return {
      uploading: false,
      progress_value: 0,
      imageURL: null,
      fileIcon: require('@/assets/document.png'),
      preview: null,
      selectFiles: [],
    }
  },
  props: {
    files: {
      type: Array,
      default: () => ([]),
    },
    accept: {
      type: String,
      default: 'image/*',
    },
  },
  created() {
    
  },
  watch: {
    
  },
  computed: {
    
  },
  methods: {
    onFocus() {
      this.$refs.fileInput.click()
    },
    //ファイルのプレビュー
    getPreview(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          resolve(e.target.result)
        }
        reader.readAsDataURL(file)
      })
    },
    //ファイルの選択
    async onFileChange($e) {
      try {
        const files = $e.target.files || $e.dataTransfer.files
        
        if (files) {
          if (files.length > 0) {
            for (const file of files) {
              const preview = await this.getPreview(file)
              this.selectFiles.push({
                preview: preview,
                file: file,
              })
            }
            this.$emit('loadedFile')
          }
        }

      } catch(e) {
        console.log(e)
      }
    },
    //ファイルアップロード
    async upload() {
      const result = await this.$confirm('ファイルをアップロードしますか？')

      if (result === true) {
        const path = this
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }

        this.progress_value = 0
        this.uploading = true

        for (const item of this.selectFiles) {
          const file = item.file
          //画像の圧縮
          let uploadFile = null
          if (this.getExt(file.name)) {
            uploadFile = await imageCompression(file, options);
          } else {
            uploadFile = file
          }

          //ファイルアップロード
          const newFile = 'uploads/' + moment().format('YYYY/MM/') + this.getUniqueName(file.name)
          const ret = await Storage.put(newFile, uploadFile, {
            progressCallback(progress) {
              path.progress_value = (progress.loaded, progress.total) * 100 / path.selectFiles.length
            }
          })

          this.files.push({
            key: ret.key,
          })
        }
        this.uploading = false
        this.selectFiles = []

        this.$emit('uploadFile')
      }
    },
    fileRemove(target) {
      this.selectFiles = this.selectFiles.filter((val, index) => index != target)
    },
    lightbox(src) {
      this.$emit('lightbox', src)
    },
    async getImageURL(key) {
      try {
        const ret = await Storage.get(key)
        this.imageURL = ret
      } catch(e) {
        console.log(e)
      }
    },
    getExt(fileName) {
      const imageExt = ['jpg', 'jpeg', 'png', 'gif']

      let pos = fileName.lastIndexOf('.')
      if (pos === -1) return false

      let ext = fileName.slice(pos + 1)
      pos = ext.indexOf('?')

      if (pos !== -1) ext = ext.slice(0, pos)

      return imageExt.find(e => e === ext.toLowerCase()) ? true : false
    },
    //削除
    componentDelete(item) {
      this.$emit('deleteFile', item)
    },
  }
}
</script>

<style lang='scss' scoped>
.upload {
  display: inline-block;
  position: relative;
  input[type=file] {
    position: absolute;
    top: 0;
    left: -9999px;
  }
  ul.upload-images {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      width: 120px;
      height: 120px;
      vertical-align: top;
      margin-right: 10px;
      position: relative;
      cursor: pointer;
      &.file-select {
        border: 1px solid #CCC;
        border-radius: 5px;
        cursor: pointer;
      }
      &.uploaded-file {
        position: relative;

      }
      .v-image {
        border-radius: 5px;
      }
      .mask {
        content: "";
        position: absolute;
        top: 5px;
        right: 2px;
        z-index: 1;
        border-radius: 5px;
        button {
          text-shadow: 0 0 5px #FFFFFF, 0 0 5px #FFFFFF;
        }
      }
    }
  }
}
</style>
